import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { BusinessInputs } from "../../../../interfaces/types/User";
import SectorOfCompanySelect from "../SectorOfCompanySelect/SectorOfCompanySelect";
import { useBusinessTypeQuery } from "../../../../rq/hooks/useQueries";
import { InputField } from "../../InputField/InputField";
import { useTranslation } from "react-i18next";
import { readFromStorage } from "../../../../utils/storage/storage";

// Intentional local calls until backend resolved approach
const businessType = {
  fr: [
    {
      label: "Achat",
      value: 4,
    },
    {
      label: "Architecture",
      value: 20,
    },
    {
      label: "Audit",
      value: 7,
    },
    {
      label: "Banque & Assurances",
      value: 12,
    },
    {
      label: "Comptabilité",
      value: 29,
    },
    {
      label: "Construction",
      value: 10,
    },
    {
      label: "Consultance",
      value: 1,
    },
    {
      label: "Culture",
      value: 27,
    },
    {
      label: "Droit",
      value: 21,
    },
    {
      label: "Engineering",
      value: 2,
    },
    {
      label: "Environnement",
      value: 24,
    },
    {
      label: "Finance",
      value: 6,
    },
    {
      label: "Formation",
      value: 25,
    },
    {
      label: "IT & Télécommunication",
      value: 5,
    },
    {
      label: "Logistique",
      value: 17,
    },
    {
      label: "Marketing",
      value: 14,
    },
    {
      label: "Media",
      value: 26,
    },
    {
      label: "Production",
      value: 9,
    },
    {
      label: "Publicité",
      value: 15,
    },
    {
      label: "Recherche & Développement",
      value: 13,
    },
    {
      label: "Ressources humaines",
      value: 11,
    },
    {
      label: "Santé",
      value: 18,
    },
    {
      label: "Secrétariat & support administratif",
      value: 8,
    },
    {
      label: "Sécurité & Protection",
      value: 23,
    },
    {
      label: "Services publics",
      value: 28,
    },
    {
      label: "Social",
      value: 19,
    },
    {
      label: "Tourisme",
      value: 22,
    },
    {
      label: "Transport",
      value: 16,
    },
    {
      label: "Vente",
      value: 3,
    },
  ],
  en: [
    {
      label: "Accounting",
      value: 29,
    },
    {
      label: "Architecture",
      value: 20,
    },
    {
      label: "Audit",
      value: 7,
    },
    {
      label: "Banking & Insurance",
      value: 12,
    },
    {
      label: "Construction",
      value: 10,
    },
    {
      label: "Consulting",
      value: 1,
    },
    {
      label: "Culture",
      value: 27,
    },
    {
      label: "Engineering",
      value: 2,
    },
    {
      label: "Environment",
      value: 24,
    },
    {
      label: "Finance",
      value: 6,
    },
    {
      label: "Health",
      value: 18,
    },
    {
      label: "Human Resources",
      value: 11,
    },
    {
      label: "IT & Telecommunication",
      value: 5,
    },
    {
      label: "Legal",
      value: 21,
    },
    {
      label: "Logistics",
      value: 17,
    },
    {
      label: "Marketing",
      value: 14,
    },
    {
      label: "Media",
      value: 26,
    },
    {
      label: "Production",
      value: 9,
    },
    {
      label: "Public Services",
      value: 28,
    },
    {
      label: "Purchasing",
      value: 4,
    },
    {
      label: "Research & Development",
      value: 13,
    },
    {
      label: "Safety & Protection",
      value: 23,
    },
    {
      label: "Sales",
      value: 3,
    },
    {
      label: "Secretarial & Administrative Support",
      value: 8,
    },
    {
      label: "Tourism",
      value: 22,
    },
    {
      label: "Transport",
      value: 16,
    },
    {
      label: "Training",
      value: 25,
    },
    {
      label: "Advertising",
      value: 15,
    },
  ],
  nl: [
    {
      label: "Accountancy",
      value: 29,
    },
    {
      label: "Architectuur",
      value: 20,
    },
    {
      label: "Audit",
      value: 7,
    },
    {
      label: "Bank & Verzekering",
      value: 12,
    },
    {
      label: "Bouw",
      value: 10,
    },
    {
      label: "Consultancy",
      value: 1,
    },
    {
      label: "Cultuur",
      value: 27,
    },
    {
      label: "Engineering",
      value: 2,
    },
    {
      label: "Financiën",
      value: 6,
    },
    {
      label: "Gezondheid",
      value: 18,
    },
    {
      label: "Human Resources",
      value: 11,
    },
    {
      label: "IT & Telecommunicatie",
      value: 5,
    },
    {
      label: "Juridisch",
      value: 21,
    },
    {
      label: "Logistiek",
      value: 17,
    },
    {
      label: "Marketing",
      value: 14,
    },
    {
      label: "Media",
      value: 26,
    },
    {
      label: "Openbare Diensten",
      value: 28,
    },
    {
      label: "Productie",
      value: 9,
    },
    {
      label: "Reclame",
      value: 15,
    },
    {
      label: "Onderzoek & Ontwikkeling",
      value: 13,
    },
    {
      label: "Veiligheid & Bescherming",
      value: 23,
    },
    {
      label: "Verkoop",
      value: 3,
    },
    {
      label: "Secretarieel & Administratieve Ondersteuning",
      value: 8,
    },
    {
      label: "Toerisme",
      value: 22,
    },
    {
      label: "Transport",
      value: 16,
    },
    {
      label: "Training",
      value: 25,
    },
  ],
};

export default function BusinessBasicInformation() {
  const locale = readFromStorage("i18nextLng");

  const { t } = useTranslation();

  const {
    register,
    formState: {
      errors: { name, numberOfWorkers },
    },
  } = useFormContext<BusinessInputs>();

  //   constants
  const getLocaleKey = (localeString: string | null) => {
    if (localeString?.startsWith("fr")) {
      return "fr";
    } else if (localeString?.startsWith("nl")) {
      return "nl";
    } else {
      return "en";
    }
  };

  const localeKey = getLocaleKey(locale);
  const businessTypeForLocale = businessType[localeKey] || businessType["en"];

  //   constants
  const businessTypeList =
    businessTypeForLocale
      ?.map((businessType) => ({
        label: businessType.label,
        value: businessType.value,
      }))
      .sort((a, b) => a.label.localeCompare(b.label)) || [];

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid item xs={12} sm={12}>
        <InputField
          label={t("basic_info.company_name")}
          type="input"
          fullWidth
          size="small"
          {...register("name")}
          fieldError={name}
        />
      </Grid>
      <SectorOfCompanySelect
        label={t("basic_info.sector_of_activity")}
        data={businessTypeList}
      />
      <Grid item xs={12} sm={6}>
        <InputField
          label={t("register.business.number_of_workers")}
          type="number"
          fullWidth
          size="small"
          {...register("numberOfWorkers")}
          fieldError={numberOfWorkers}
        />
      </Grid>
    </Grid>
  );
}
